// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1WLqc","gfeWrapper":"CalendarEvent_gfeWrapper__5Hqo3"};